import { currentUserType } from "../../../utils";
import { useSelectedChatChannel } from "./SelectedChannel";

export const useChatSettings = () => {
  const { selectedChatChannel } = useSelectedChatChannel();

  // Suggest AI drafts
  const shouldSuggestDrafts = currentUserType === "Provider";

  // Chatbox placeholder text
  const chatBoxPlaceholderText = `Message ${selectedChatChannel?.respondent?.display_name}`;

  // Automatically mark selected chat channel as read
  const shouldAutomaticallyMarkSelectedChatChannelAsRead =
    currentUserType === "Patient";
  return {
    chatBoxPlaceholderText,
    shouldSuggestDrafts,
    shouldAutomaticallyMarkSelectedChatChannelAsRead,
  };
};
